<template>
  <div @click="isOpen = ! isOpen">

    <span class="relative inline-block">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 cursor-pointer hover:opacity-100 "
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="{    'opacity-25' : ! isOpen && ! filterInitial.length ,'opacity-80' :  isOpen || filterInitial.length }"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg>
    </span>
    <jet-dialog-modal
      :show="isOpen"
      @close="isOpen = false"
      :closeable="false"
      max-width="4xl"
    >
      <template #title>
      </template>
      <template #content>
        <search-bar
          v-if="isOpen"
          :campos="campos"
          @change="adicionarFiltro($event)"
          :filter-initial="filterInitial"
          style-list="flex space-x-3 justify-start"
        ></search-bar>
      </template>
      <template #footer>
        <div class="flex justify-around md:justify-end space-x-6">
          <div class="flex-1 md:flex-none">
            <button-secondary
              class="w-full  "
              @click.native="cancelar"
            >
              <div class="mx-auto">Cancelar</div>
            </button-secondary>
          </div>
          <div class="flex-1 md:flex-none">
            <button-primary
              class="w-full  "
              :class="{ 'opacity-25': false}"
              :disabled="false"
              @click.native="aplicar"
            >
              <div class="mx-auto">Aplicar</div>
            </button-primary>
          </div>

        </div>
      </template>
    </jet-dialog-modal>

  </div>

</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import SearchBar from '@/Components/SearchBar';

export default {
  components: { JetDialogModal, ButtonPrimary, ButtonSecondary, SearchBar },
  props: ['campos', 'filterInitial'],
  data() {
    return {
      isOpen: false,
      filtros: []
    }
  },
  methods: {
    adicionarFiltro(event) {
      this.filtros = [...event];
    },
    aplicar() {
      this.$emit('apply', [... this.filtros])
      this.isOpen = false;
    },
    cancelar() {
      this.filtros = [...this.filterInitial];
      this.isOpen = false;
    }
  }
}
</script>

<style>
</style>
